/* @jsx h */
import { defineComponent, h, ref, computed } from "vue";
import { useLocalization } from "@lemmonhq/uikit";

interface Category {
  name: string;
  count: number;
  icon: string;
}

export const CategoryFilter = defineComponent({
  props: {
    categories: {
      type: Array as () => Category[],
      required: true,
    },
    selectedCategory: {
      type: String,
      default: "all",
    },
  },
  emits: ["update:selectedCategory"],
  setup(props, { emit }) {
    const { t } = useLocalization();
    const allCategories = computed(() => [
      {
        name: "all",
        count: props.categories.reduce((sum, cat) => sum + cat.count, 0),
        icon: "restaurant",
      },
      ...props.categories,
    ]);

    const handleCategorySelect = (categoryName: string) => {
      emit("update:selectedCategory", categoryName);
    };

    return () => (
      <div class="mb-12">
        {/* Section Header */}
        <div class="text-center mb-8">
          <h3 class="text-2xl font-serif font-light text-gray-900 mb-2">
            {t("customer.home.browse_by_category")}
          </h3>
          <div class="w-16 h-px bg-gray-300 mx-auto"></div>
        </div>

        {/* Category Pills */}
        <div class="flex flex-wrap justify-center gap-3">
          {allCategories.value.map((category) => (
            <button
              key={category.name}
              onClick={() => handleCategorySelect(category.name)}
              class={`group flex items-center gap-2 px-6 py-3 border transition-all duration-300 ${
                props.selectedCategory === category.name
                  ? "border-gray-900 bg-gray-900 text-white"
                  : "border-gray-300 text-gray-700 hover:border-gray-400"
              }`}
            >
              <span class="material-symbols-outlined text-sm">
                {category.icon}
              </span>
              <span class="font-medium capitalize tracking-wide">
                {category.name === "all"
                  ? t("customer.home.all_restaurants")
                  : category.name}
              </span>
              <span
                class={`text-xs font-medium px-2 py-1 rounded-full ml-1 ${
                  props.selectedCategory === category.name
                    ? "bg-white text-gray-900"
                    : "bg-gray-100 text-gray-600"
                }`}
              >
                {category.count}
              </span>
            </button>
          ))}
        </div>
      </div>
    );
  },
});
